import React from 'react';
import { Link } from 'react-router-dom';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Helmet from 'helmet/helmet';
import { RouteComponentProps } from 'react-router';

import { Site } from 'four-nets/site';

import LatestVendorsProducts from '../latest-vendors-products/latest-vendors-products';
import CatalogNavigationLoader from './catalog-navigation/catalog-navigation-loader';
import VendorAlbums from './vendor-albums/vendor-albums';

import defaultStyles from './catalog.scss';
import { HideForVendor } from '../permissions';
import HtmlComponent from 'lib/html-component';

interface Props extends RouteComponentProps {
    styles: typeof defaultStyles;
}

class Catalog extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
        origin: PropTypes.string,
    };

    renderHelmet = (H: React.ComponentClass) => {
        const { site, origin } = this.context;
        const { location } = this.props;

        if (site.isWedding) {
            return (
                <FormattedMessage id='WEDDING_CATALOG'>
                    {message => (
                        <H>
                            <title>
                                {message} | {site.name}
                            </title>
                            ,
                            <meta property='og:title' content={message as string} />,
                            <meta property='og:url' content={`${origin}/${location.pathname}`} />,
                        </H>
                    )}
                </FormattedMessage>
            );
        } else {
            return (
                <FormattedMessage id='BUSINESS_DIRECTORY'>
                    {message => (
                        <H>
                            <title>
                                {message} | {site.name}
                            </title>
                            ,
                            <meta property='og:title' content={message as string} />,
                            <meta property='og:url' content={`${origin}/${location.pathname}`} />,
                        </H>
                    )}
                </FormattedMessage>
            );
        }
    };

    render() {
        const { styles } = this.props;
        const { site } = this.context;

        return (
            <div>
                <Helmet render={this.renderHelmet} />

                <div className={styles.headingDiv}>
                    <FormattedMessage id='BUSINESS_DIRECTORY'>
                        {msg => <h1 className={styles.heading}>{msg}</h1>}
                    </FormattedMessage>
                    <div className={styles.buttonsContainers}>
                        {site.isWedding && (
                            <HideForVendor>
                                <Link
                                    to={site.isCzech ? '/poptavac' : '/dopytovac'}
                                    style={{ marginRight: 15 }}
                                    className={styles.demanderLink}
                                >
                                    {site.isCzech ? 'Jsi nevěsta? Zadej poptávku' : 'Si nevesta? Zadaj dopyt'}
                                </Link>
                            </HideForVendor>
                        )}

                        <HideForVendor>
                            <Link to='/pro-landing/' className={styles.registerLink}>
                                <FormattedMessage id='ADD_VENDOR' />
                            </Link>
                        </HideForVendor>
                    </div>
                </div>
                <div className={styles.mobilePadding}>
                    <CatalogNavigationLoader />
                </div>
                <VendorAlbums />
                <HtmlComponent url='/market/react/catalog/products/' />
            </div>
        );
    }
}

export default Styled(defaultStyles)(Catalog);
